

















import BaseComponent from "@/components/BaseComponent.vue";
import { Component } from "vue-property-decorator";
import app from "@/app";

@Component
export default class WSplash extends BaseComponent {
	appName = app.configs.get("OW_APP_NAME");
	appLogo = app.configs.get("OW_APP_LOGO_SRC");
}
